module.exports = __webpack_public_path__ + "static/media/guiaDeEstudioSegundoExamen.c3ecce98.pdf";